import { IPROP_MAP, modifyProps } from '../../generators/modifyProps';
import { ReactElement, useEffect, useState } from 'react';

import { CTA } from '../jdscontentblock/interface';
import { Devices } from '../../service/Devices';
import { JDSNotificationBannerProps } from './generated';
import { LinkProps } from '../jdslink/logic';
import { TextProps } from '../jdstext/logic';
import { resolvePropObjectKeys } from '../../utils/componenthelpers';

export interface NotificationBannerProps
  extends Omit<JDSNotificationBannerProps, 'suffix' | 'cta' | 'description'> {
  /**
   * Accepts description as string or Text Element for custom styling
   * Passing Listblock props is deprecated. Please pass a string
   */
  description?: string | ReactElement<TextProps>;
  /**
   * This accepts Link properties such as href, newTab etc. Please refer `Link>LinkType` for more.
   * When banner is Non-Dismissable, click on cta does not close the banner otherwise, cta will always close the banner on click.
   */
  cta?: string | LinkProps;
  /**
   * The suffix icon to be displayed. If nothing is passed, close icon is shown.
   * When null is provided, the banner is Non-Dismissable and no icon is shown
   */
  suffix?: string | JSX.Element | null;
}

export const PROP_MAP: IPROP_MAP<NotificationBannerProps> = (props) => {
  if (typeof props.description === 'object') {
    console.warn('Passing Listblock props is deprecated. Please pass a string');
  }
  return {
    cta: {
      properties: {
        cta: resolvePropObjectKeys(props.cta, 'title', ''),
        onCTAClick: (props.cta as CTA)?.onClick
      }
    }
  };
};

export const withLogic =
  (
    Component: React.ComponentType<NotificationBannerProps>
  ): React.FC<NotificationBannerProps> =>
  (userProps: NotificationBannerProps) => {
    const props = modifyProps(userProps, PROP_MAP);
    const [open, setOpen] = useState(props.open);
    const [internalOpen, setInternalOpen] = useState(props.open);

    useEffect(() => {
      if (props.open) {
        setOpen(true);
        setTimeout(() => {
          setInternalOpen(true);
        }, 10);
      } else {
        setOpen(false);
        setTimeout(() => setInternalOpen(false), 500);
      }
    }, [props.open]);

    const getPlatform = () => {
      if (Devices.isMobile()) {
        return 'mobile';
      }
      if (Devices.isTablet()) return 'tablet';
      return 'desktop';
    };

    const expandedClass = internalOpen && open ? 'expanded' : '';
    const classes = [expandedClass];
    console.log(props.suffix, 100);

    return (
      <Component
        {...{
          ...props,
          open: open || internalOpen,
          _showClose: !(props.suffix === null),
          _platform: getPlatform(),
          className: classes.join(' '),
          suffix: props.suffix === undefined ? 'IcClose' : props.suffix,
          onSuffixClick: (ev: React.MouseEvent<HTMLDivElement>) => {
            if (props.closeOnSuffixClick) {
              setOpen(false);
              setTimeout(() => {
                setInternalOpen(false);
              }, 500);
            }
            props.onSuffixClick?.(ev);
          }
        }}
      />
    );
  };
